module.exports = __webpack_public_path__ + "static/img/school01.0db6723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/school/school01.png
// module id = KDOY
// module chunks = 2